import { Expose } from "class-transformer";
import { IsArray, IsOptional, IsString } from "class-validator";

export class SetCountyCoverageInput {
  @Expose()
  @IsArray()
  @IsString({ each: true })
  fips: string[];

  @Expose()
  @IsOptional()
  @IsString()
  accountManagerId?: string | null;

  @Expose()
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  release?: string[];
}
